import phoneInputStyles from '../PhoneInput/styles';

export default {
  input: {
    ...phoneInputStyles.phoneInput,
  },
};
